import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/manrope";
import "@fontsource-variable/newsreader";
import { App } from "./App";
import { ActionsProvider } from "./app-context";
import { CatalogGateway, ShopifyCatalogClient, catalogModeFromSearch } from "./catalog/client";
import { ApplicationActions } from "./domain/engine";
import { registerProductistTools } from "./webmcp/adapter";
import { installDirectToolHarness } from "./webmcp/harness";
import "./styles.css";

const params = new URLSearchParams(window.location.search);
if (params.get("webmcpHarness") === "1") installDirectToolHarness(document, window);

const liveCatalog = new ShopifyCatalogClient("/api/catalog", window.location);
const gateway = new CatalogGateway(liveCatalog, catalogModeFromSearch(window.location.search));
const actions = new ApplicationActions(gateway, window.localStorage);
const cleanupTools = registerProductistTools(document, actions);

window.addEventListener("pagehide", cleanupTools, { once: true });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ActionsProvider actions={actions}>
      <App />
    </ActionsProvider>
  </React.StrictMode>,
);
